<template>
  <div>
    <!--  优惠券生成 -->
    <el-dialog :title="$t('message.couponsSpecifieds')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1788px" center>
      <div class="content">
        <div class="add">
          <el-button type="success" @click="addItem">{{
            $t("message.add")
          }}</el-button>
        </div>
        <el-table :data="discount" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" size="small">
          <el-table-column align="center" label="NO" type="index" width="60">
          </el-table-column>
          <!-- 券名称 -->
          <el-table-column align="center" :label="$t('message.couponName')" prop="name_translation" width="200">
            <template slot-scope="scope">
              <div>
                <el-select v-model="scope.row.group_id" placeholder="请选择" @change="changeType($event, scope.$index)">
                  <el-option v-for="item in tableData" :key="item.id" :label="item.name_translation" :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <!-- 使用时间 -->
          <el-table-column align="center" :label="$t('message.effectiveDate')" width="480">
            <template slot-scope="scope">
              <div style="margin-bottom: 10px;">
                <el-button size="mini" type="primary" @click="setTime(scope.$index, 30)">30天</el-button>
                <el-button size="mini" type="primary" @click="setTime(scope.$index, 60)">60天</el-button>
                <el-button size="mini" type="primary" @click="setTime(scope.$index, 90)">90天</el-button>
              </div>
              <el-date-picker v-model="scope.row.effective_date" :placeholder="$t('message.startDate')" type="datetime"
                default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
              -
              <el-date-picker v-model="scope.row.expiry_date" :placeholder="$t('message.dateClosed')"
                default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </template>
          </el-table-column>
          <!-- 类别 -->
          <el-table-column align="center" :label="$t('message.category')">
            <template slot-scope="scope">
              <span :style="{ color: scope.row.type == 1 ? '#2C96E7' : '#B4272D' }" v-if="scope.row.type">{{
                scope.row.type_name
              }}</span>
            </template>
          </el-table-column>
          <!-- 额度/可用次数/折扣比例 -->
          <el-table-column align="center" label="额度/可用次数/折扣比例/天">
            <template slot-scope="scope" v-if="scope.row.fee">
              <span :style="{ color: scope.row.type == 1 ? '#2C96E7' : '#B4272D' }" v-if="scope.row.type != '3'">
                {{ scope.row.fee }}
              </span>
              <span v-else>
                {{
                  scope.row.fee && scope.row.fee != "0"
                    ? scope.row.fee
                    : scope.row.rate + "%"
                }}</span>
            </template>
          </el-table-column>
          <!-- 使用限制 -->
          <el-table-column align="center" :label="$t('message.useRestrictions')" prop="min_consumption">
            <template slot-scope="scope">
              <div v-if="scope.row.type <= 3">


                <span v-if="scope.row.type != '3'">订单金额 >={{ scope.row.min_consumption }}</span>
                <div v-else>
                  <p>订单金额 >={{ scope.row.min_consumption }}</p>
                  <p>计费重量 >={{ scope.row.min_weight }}</p>
                  <p>
                    <el-select :disabled="true" v-model="scope.row.logistics_id" multiple placeholder="全部物流">
                      <el-option v-for="(yitem, oindex) in Logisticsoptions" :key="oindex" :label="yitem.name"
                        :value="yitem.id">
                      </el-option>
                    </el-select>
                  </p>
                </div>
              </div>
              <div v-else>
                无
              </div>
            </template>
          </el-table-column>
          <!-- 数量 -->
          <el-table-column align="center" :label="$t('message.quantity')" prop="name_translation">
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.num"></el-input>
            </template>
          </el-table-column>
          <!--  申请人-->
          <el-table-column align="center" :label="$t('message.theApplicant')" prop="apply_by">
            <template slot-scope="scope">
              <el-select v-model="scope.row.apply_by" placeholder="请选择" filterable>
                <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <!--  申请原因-->
          <el-table-column align="center" :label="$t('message.reasonForApplication')" prop="apply_reason" width="180px">
            <template slot-scope="scope">

              <el-input v-model="scope.row.apply_reason" type="textarea"></el-input>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column align="center" :label="$t('message.operation')">
            <template slot-scope="scope">
              <!-- 删除 -->
              <p>
                <el-button size="small" type="primary" class="dark" @click="deleteDiscountGroup(scope.$index)">
                  {{ $t("message.delete") }}
                </el-button>
              </p>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getCurrentTime } from '../../../../../../utlis/date'
export default {
  data() {
    return {
      dialogVisible: false,
      i: 0,
      tableData: [],
      discount: [],
      Logisticsoptions: [],
    };
  },
  computed: {
    y() {


      return this.$store.state.authWorkGroupAdmin.y
    }
  },
  created() {
    this.$api.clienteleApi.getDiscountLogistics().then((res) => {
      res.data.forEach((element) => {
        element.id = element.id + "";
      });
      this.Logisticsoptions = res.data;
    });
  },
  methods: {
    getDiscountGroup() {
      this.$api.clienteleApi.getDiscountGroup().then((res) => {
        res.data.forEach((dataItem) => {
          if (dataItem.logistics_id) {
            let arr = dataItem.logistics_id.split(",");
            dataItem.logistics_id = arr;
            dataItem.logistics = 1;
          } else {
            dataItem.logistics = 0;
          }
          if (!isNaN(dataItem.min_weight)) {
            dataItem.min_weight = Number(dataItem.min_weight);
          }
        });
        this.tableData = res.data;
      });
    },
    // 新增
    addItem() {
      this.discount.push({
        group_id: "",
        user_id: this.$route.query.userID,
        effective_date: getCurrentTime(0) + ' 00:00:00',
        expiry_date: getCurrentTime(60) + ' 23:59:59',
        num: "",
      });
    },
    // 保存
    save() {
      this.$api.clienteleApi
        .saveDiscount({ discount: this.discount })
        .then((res) => {
          this.$message.success(res.msg);
          this.dialogVisible = false;
          this.discount = [];
          this.$parent.getDiscount();
        });
    },
    // 类别
    changeType(e, i) {
      let item = this.tableData.find((item) => item.id == e);
      this.discount[i].type = item.type;
      this.discount[i].type_name = item.type_name;
      this.discount[i].min_consumption = item.min_consumption;
      this.discount[i].fee = item.fee;
      this.discount[i].rate = item.rate;
      this.discount[i].min_weight = item.min_weight;
      this.discount[i].logistics_id = item.logistics_id;
      this.$forceUpdate();
    },
    //编辑
    edit(item) {
      this.ruleForm = item;
      this.title = this.$t("message.redact");
      this.addDialogVisible = true;
    },
    // 删除
    deleteDiscountGroup(i) {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.discount.splice(i, 1);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    //设置时间
    setTime(index, num) {
      this.discount[index].effective_date = getCurrentTime(0) + ' 00:00:00'
      this.discount[index].expiry_date = getCurrentTime(num) + ' 23:59:59'
      this.$forceUpdate()
    },
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.getDiscountGroup();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  margin: 0px 15px;
}

.add {
  margin: -40px 0 20px;
  text-align: right;
}

/deep/.el-radio__input {
  transform: scale(1.2) !important;
}

/deep/.el-select {
  width: 100%;
}
</style>
